'use client';

import { FeatureViewed } from '@repo/segment/components/FeatureViewed';

type BankingAssessmentBannerControlTrackerProps = {
  isExperimentActive: boolean;
};

export function BankingAssessmentBannerControlTracker({
  isExperimentActive,
}: BankingAssessmentBannerControlTrackerProps) {
  if (!isExperimentActive) {
    return null;
  }

  return (
    <FeatureViewed entityName="baf_control_banner" entitySection="banking">
      <div style={{ height: 0, overflow: 'hidden' }} />
    </FeatureViewed>
  );
}
